<template>
  <div>
    <my-dialog
      :is-show-footer="false"
      :dialog-carted="videoButton"
      :width="640"
      title="视频录像"
      @confirmOk="closeDialog"
    >
      <template #content>
        <div v-if="hasData">
          <div v-if="hasPermission" class="select-video">
            <el-select
              v-model="carTimePath"
              placeholder="请选择"
              @change="selectVideo"
            >
              <el-option
                v-for="item in carData"
                :key="item.start"
                :label="item.start"
                :value="item.filename"
              />
            </el-select>
            <div id="mse"/>
          </div>
          <div
            v-else
            class="ask-permission-button"
            @click="getPermissionForHistory"
          >
            <span>请求权限</span>
          </div>
        </div>
        <div v-else>
          <img src="@/assets/photos/1920.png" style="height: 360px" alt="">
        </div>
      </template>
    </my-dialog>
    <!-- 发送成功弹窗 -->
    <my-dialog
      :dialog-carted="dialogSuccess"
      :width="560"
      form-title="提示"
      @confirmOk="dialogSuccess = false"
    >
      <template #content>
        <div>发送成功，请等待管理员同意！</div>
      </template>
    </my-dialog>
  </div>
</template>

<script>
import MyDialog from "@components/customDialog/MyDialog";
import { askPermission } from "@api/permission";
import { getCarVideo } from "@api/streamdata";
import { showWindowMessage } from "@utils/notification";
import Player from "xgplayer";
import { baseUrl } from "@utils/base";
import { mapState } from "vuex";

export default {
  name: "CamaraShow",
  components: {
    MyDialog
  },
  props: {
    videoButton: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },
  emits: ["closeDialog"],
  data() {
    return {
      hasPermission: false,
      carData: [],
      hasData: false, // 是否有数据
      player: null,
      carTimePath: "", // 监控时间
      patientID: 0,
      askPermissionForm: {},
      dialogSuccess: false,
      userID: "", // 用户真实id
      completeHeartUrl: "",
      baseUrl: baseUrl,
    };
  },
  computed: {
    ...mapState({
      userInfo: "userInfo",
      hospitalID: "hospitalID"
    })
  },
  watch: {
    videoButton: {
      handler(newVal, old) {
        if (newVal) {
          this.patientID = this.$route.params.id;
          this.userID = this.userInfo.id;
          // console.log("我后面执行");
          this.getCarData();
        } else {
          !!this.player && this.player.pause();
        }
      },
      immediate: true
    },
  },
  mounted() {
    // console.log("我前面执行");
    this.patientID = this.$route.params.id;
    this.userID = this.userInfo.id;
  },
  beforeUnmount() {
    this.player?.destroy(false);
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    selectVideo(path) {
      this.player.src = this.baseUrl + path;
    },
    // 请求视频权限
    async getPermissionForHistory() {
      this.askPermissionForm = {
        type: "checkData",
        userId: this.userID,
        hospitalId: this.hospitalID, // 从store中获得
        medicalhistoryId: this.patientID
      };
      const { code } = await askPermission(this.askPermissionForm);
      if (code === "1") {
        this.dialogSuccess = true;
        this.dialogMessage = "发送成功，请等待管理员同意！";
      } else {
        this.dialogSuccess = true;
        this.dialogMessage = "请求失败，请联系管理员！";
      }
    },

    // 视频点击事件
    async getCarData() {
      try {
        const { code, data } = await getCarVideo(this.patientID);
        if (code === 405) {
          // 没有权限
          this.hasPermission = false;
          this.hasData = true;
          return;
        }
        if (code === 404) {
          this.hasData = false;
          this.hasPermission = true;
          return;
        }
        this.hasData = true;
        this.hasPermission = true;
        this.carData = data;
        await this.$nextTick(() => {
          this.carTimePath = this.carData[0].filename;
          this.completeHeartUrl = this.baseUrl + this.carTimePath;
          this.getPlayer();
        });
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    getPlayer() {
      this.player = new Player({
        el: document.querySelector("#mse"),
        url: this.completeHeartUrl,
        videoInit: true,
        loop: true,
        playbackRate: [0.5, 0.75, 1, 1.25], // 传入倍速可选数组
        defaultPlaybackRate: 1,

      });
    },
  }
};
</script>

<style scoped lang="scss">
.ask-permission-button {
  display: inline-block;
  width: 80px;
  height: 30px;
  background: #0c618b73;
  box-shadow: 0 0 6px 0 rgba(6, 53, 76, 0.5);
  border-radius: 6px;
  line-height: 30px;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  span {
    font-size: 14px;
    cursor: pointer;
    font-weight: bold;
    color: #efefef;
  }
}
</style>
